import React, {useRef} from 'react';
import {formatDate, formatMigrationStatus} from "../../../../util/Helpers";
import {Modal} from "react-bootstrap";
import {useGetUserMigrationLogsQuery} from "../../../../../redux/apiSlice";

function MigrationDetails({showMigrationDetailsModal, onHide, migrationStatus}) {
    const timeRef = useRef(new Date().getTime());
    const {isFetching: isLoadingLogs, data: migrationLogs} = useGetUserMigrationLogsQuery({userId: migrationStatus?.user?.unique_id, sessionId: timeRef.current})

    return (
        <Modal
            size="lg"
            show={showMigrationDetailsModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Migration Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                <div className="row">
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Profile
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.profileMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">KYC
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.kycMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Watchlist
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.watchlistMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Bank
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.bankMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Documents
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.docsMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Paper
                            Account Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.paperAccMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">US Account
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.usAccMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                    {/* <!--begin::Field--> */}
                    <div className="col-4 mt-0 mb-2 pr-3">
                        <div
                            className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">NG Account
                            Migration
                        </div>
                        <div
                            className="text-muted font-weight-bold font-size-sm my-1"> {formatMigrationStatus(migrationStatus?.ngAccMig)}</div>
                    </div>
                    {/* <!--end::Field--> */}
                </div>
                <h4 className={"my-4"}>Logs</h4>
                {isLoadingLogs
                    ? <div>Loading...</div>
                    : <div>
                        {
                            migrationLogs?.map((entry) => {
                                return (
                                    <div key={entry.id} className={"row mb-3"}>
                                        <div className={"col-4"}>
                                            {formatDate(entry.createdAt)}
                                        </div>
                                        <div className={"col"}>
                                            {entry.error}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <button
                    onClick={onHide}
                    className="btn btn-light btn-elevate px-4"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default MigrationDetails;